<a
  *ngIf="isLink(item) && !isFunction(item.route)"
  [fragment]="item.fragment"
  [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
  [routerLink]="item.route"
  class="item my-2"
  fxLayout="row"
  matRipple
  routerLinkActive="active"
>
  <mat-icon
    *ngIf="level === 0"
    [icIcon]="item.icon"
    class="item-icon"
    fxFlex="none"
  ></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label }}</span>
  <!--
<span *ngIf="item.label=='إدارة العملاء' || item.label=='ادارة التحويلات' || item.label=='طلابات التمويل' || item.label=='إدارة الحسابات البنكية' || item.label=='ادارة الشكاوي' || item.label=='ادارة التقارير' || item.label=='الاشتراكات'" class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">99+</span>
    -->

    <span matBadge="{{ (todos$ | async).fundTransferCount }}" *ngIf="item.label=='ادارة التحويلات'"></span>
    <span matBadge="{{ (todos$ | async).inscriptionCount }}" *ngIf="item.label=='إدارة العملاء'"></span>
    <span matBadge="{{ (todos$ | async).fundLoanCount }}" *ngIf="item.label=='طلابات التمويل'"></span>
    <span matBadge="{{ (todos$ | async).reportCount }}" *ngIf="item.label=='ادارة الشكاوي'"></span>
    <span matBadge="{{ (todos$ | async).reportTransportCount }}" *ngIf="item.label=='إدارة شكاوي النقل'"></span>
    <span matBadge="{{ (todos$ | async).sellerCount }}" *ngIf="item.label=='بائع'"></span>
    <span matBadge="{{ (todos$ | async).buyerCount }}" *ngIf="item.label=='شاري'"></span>
    <span matBadge="{{ (todos$ | async).controllerCount }}" *ngIf="item.label=='مراقب'"></span>
    <span matBadge="{{ (todos$ | async).buyerSellerCount }}" *ngIf="item.label=='بائع شاري'"></span>
    <span matBadge="{{ (todos$ | async).marketerCount }}" *ngIf="item.label=='مسوّق'"></span>
    <span matBadge="{{ (todos$ | async).transporterCount }}" *ngIf="item.label=='موصل'"></span>
    <span matBadge="{{ (todos$ | async).ibanChangeDemandCount }}" *ngIf="item.label=='إدارة الحسابات البنكية'"></span>
    <span matBadge="{{ (todos$ | async).receiveMoneyCount }}" *ngIf="item.label=='طلبات سحب الرصيد'"></span>
    <span matBadge="{{ (todos$ | async).messageCount }}" *ngIf="item.label=='الرسائل الواردة'"></span>
    <span matBadge="{{ (todos$ | async).productCount }}" *ngIf="item.label=='إدارة المنتجات'"></span>


  <span
    *ngIf="item.badge"
    [ngClass]="[item.badge.bgClass, item.badge.textClass]"
    class="item-badge"
    fxFlex="none"
    >{{ item.badge.value }}</span
  >
</a>

<div
  (click)="item.route()"
  *ngIf="isLink(item) && isFunction(item.route)"
  class="item"
  fxLayout="row"
  matRipple
  routerLinkActive="active"
>
  <mat-icon
    *ngIf="level === 0"
    [icIcon]="item.icon"
    class="item-icon"
    fxFlex="none"
  ></mat-icon>
  <span class="item-label" fxFlex="auto">{{ item.label }}</span>
  <span
    matBadge="{{ (todos$ | async).inscriptionCount }}"
    *ngIf="item.label == 'إدارة العملاء'"
  ></span>
  <span
    *ngIf="item.badge"
    [ngClass]="[item.badge.bgClass, item.badge.textClass]"
    class="item-badge"
    fxFlex="none"
    >{{ item.badge.value }}</span
  >
</div>

<ng-container *ngIf="isDropdown(item)">
  <div
    (click)="toggleOpen()"
    [class.active]="isOpen || isActive"
    [class.open]="isOpen"
    class="item"
    fxLayout="row"
    matRipple
  >
    <mat-icon
      *ngIf="level === 0"
      [icIcon]="item.icon"
      class="item-icon"
      fxFlex="none"
    ></mat-icon>
    <span class="item-label" fxFlex="auto">{{ item.label }}</span>
    <span
      matBadge="{{ (todos$ | async).inscriptionCount }}"
      *ngIf="item.label == 'إدارة العملاء'"
    ></span>
    <span
      *ngIf="item.badge"
      [ngClass]="[item.badge.bgClass, item.badge.textClass]"
      class="item-badge"
      fxFlex="none"
      >{{ item.badge.value }}</span
    >
    <mat-icon
      [icIcon]="icKeyboardArrowRight"
      class="item-dropdown-icon"
      fxFlex="none"
    ></mat-icon>
  </div>
  <div [@dropdown]="isOpen" class="item-dropdown">
    <ng-container *ngFor="let subItem of item.children">
      <vex-sidenav-item
        *ngIf="permissions.includes(subItem?.name)"
        [item]="subItem"
        [level]="level + 1"
      ></vex-sidenav-item>
    </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="isSubheading(item)">
  <div class="subheading">{{ item.label }}</div>

  <ng-container *ngFor="let subItem of item.children">
    <vex-sidenav-item
      *ngIf="permissions.includes(subItem?.name)"
      [item]="subItem"
      [level]="0"
    >
    </vex-sidenav-item>
  </ng-container>
</ng-container>
